import { post } from './request'

export function floorAdd(data) {
  return post('/api/Floor/Add', data)
}

export function floorUpdate(data) {
  return post('/api/Floor/Update', data)
}

export function floorList(data) {
  return post('/api/Floor/List', data)
}

export function floorDetail(data) {
  return post('/api/Floor/Detail', data)
}

export function floorDelete(data) {
  return post('/api/Floor/Delete', data)
}
